import { useQuery } from '@tanstack/react-query';
import { getDecisionOverrideRationales } from '../individualLoanDetailsService';
import { AuthenticationContextType } from 'Foundation/Authentication';

export const useDecisionOverrideRationales = (authenticationContext: AuthenticationContextType) => {
  return useQuery({
    queryKey: ['decision-override-rationales'],
    queryFn: () => getDecisionOverrideRationales({ authenticationContext }),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false
  });
};
